import Axios from '../baseApi'
export default {
  addOrUpdateRange(factoryId, groupId, deliveryPrograms) {
    if(groupId === 'null')
      groupId = null;
    return Axios.post(`/api-master-data/factory-delivery-programs/v1/${factoryId}/${groupId}`, deliveryPrograms);
  },
  fetch(factoryId, groupId) {
    return Axios.get(`/api-master-data/factory-delivery-programs/v1/${factoryId}/${groupId}`);
  }
}
